// Global configuration for Unlock Request date constraints
// Edit this file to change the cutoff date dynamically

import moment from 'moment';

export const UNLOCK_CONFIG = {
  // Dates before this are disabled/not selectable in UnlockRequest calendars
  // Format: 'YYYY-MM-DD'
  minAllowedDate: '2026-04-26',  // Change this to adjust the cutoff date
};

// Helper function to get the min allowed date as a Date object
export const getMinAllowedDate = () => {
  return moment(UNLOCK_CONFIG.minAllowedDate, 'YYYY-MM-DD').toDate();
};

// Helper function to check if a date is allowed (on or after minimum allowed date)
export const isDateAllowed = (date) => {
  // Handle Date objects directly
  const checkDate = moment(date);
  const minDate = moment(UNLOCK_CONFIG.minAllowedDate, 'YYYY-MM-DD');
  
  // Returns true if date is on or after minDate
  return checkDate.isSameOrAfter(minDate, 'day');
};
